import React from 'react';
import {
  Container, Image
} from 'react-bootstrap';
import { Tron } from './Tron';

export const MacOs = () => {
  
  let homeTron = {
    title: 'Workspace ONE MacOs Excel Add-In (Beta)',
    description: 'This is the installation documentation page for the Workspace ONE MacOs Excel Add-In.',
    body: <>
      <p>This covers using this website to run the Add-In.</p>
      <p><b>However,</b> this is mostly for evaluation purposes since, for security and privacy reasons,
        there is no caching layer implemented at this time so your speed will be much higher
        with a <a href='./APIBackendWindows'>Caching API implemented</a></p>
      <p>This is easier than you think.</p>
    </>
  };
  
  
  return (
    
    <Container>
      <Tron tronProps={homeTron}/>
      <Container>
        <h4 id="copy-and-edit-manifest.xml">Copy and edit Manifest.xml</h4>
        <p>The first thing you need to do is go to the <a
          href="https://github.com/vmware-samples/euc-samples">VMware Samples GitHub</a> and download the euc-samples
          repository. Once downloaded, unzip it, and open the euc-samples-master folder, then Windows-Samples,
          Tools &amp; Utilities, and finally Excel Add-In.</p>
        <p>Copy the manifest.xml to a temporary folder on your computer</p>
        <h5>Edit the manifest.xml</h5>
        <Image alt="Edit Manifest" width='800' src='../images/WSONEEditManifest.png' fluid/>
        <ul>
          <li>Right click on the manifest.xml and click edit</li>
          <li>Click Open the Edit menu and click Replace</li>
          <li>In "Find What" put /localhost/</li>
          <li>In "Replace With" put /wsonereporting.azurewebsites.net/</li>
          <li>Click "Replace All"</li>
          <li>Save your manifest.xml</li>
        </ul>
        
        <h4>Put the manifest.xml into the proper folder</h4>
        <ul>
          <li>
            <p>Open Terminal and go to the following folder where you'll save your add-in's manifest.xml file. If
              the
              wef folder doesn't exist on your computer, create it.</p>
            <p>cd /Users/YourUserName/Library/Containers/com.microsoft.Excel/Data/Documents/wef</p>
          </li>
          <li>
            <p>Open the folder in Finder using the command "open ." (including the dot). Copy your add-in's
              manifest file to this folder.</p>
            
            <img alt="Your Excel Folder" width="500 " src="../images/WSOneWefFolder.png"/>
          </li>
          <li>
            <p>Open Excel, and then open a Spreadsheet. Restart Excel if it's already running.</p>
          </li>
          <li>
            <p>In Excel, choose Insert {'>'} Add-ins {'>'} My Add-ins (drop-down menu), and then choose your add-in.</p>
            <img src="../images/WSOneInsertAddin.png" alt="Insert AddIn" width="500"/>
            <blockquote>
              [!IMPORTANT] Sideloaded add-ins will not show up in the My Add-ins dialog box. They are only visible
              within the drop-down menu (small down-arrow to the right of My Add-ins on the Insert tab).
              Sideloaded add-ins are listed under the Developer Add-ins heading in this menu.
            </blockquote>
          </li>
          <li>
            <p>Verify that your add-in is displayed in Excel.</p>
            <img src="../images/WSOneVerifyAddin.png" alt="Verify AddIn" width="500"/>
          </li>
        </ul>
      
      </Container>
    </Container>
  );
};

